// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"87b71f47","351":"5613162d","886":"4fa5ff69","974":"d3ed7aad"}[chunkId] + ".chunk.js";
};